const FINANCIAL_REPORT_PATH = '/financial-report-download.php';

export const normalizePrivateFinancialArtifactUrl = (source = {}, apiBase = '') => {
    if (!source || typeof source !== 'object') return source;

    const rawUrl = String(source.url || '').trim();
    const rawDownloadUrl = String(source.download_url || '').trim();
    const isFinancialArtifact = String(source.artifact_kind || '').toLowerCase() === 'financial_period_workbook'
        || rawUrl.startsWith(FINANCIAL_REPORT_PATH)
        || rawDownloadUrl.startsWith(FINANCIAL_REPORT_PATH)
        || /\/financial-report-download\.php(?:[?#]|$)/i.test(rawUrl)
        || /\/financial-report-download\.php(?:[?#]|$)/i.test(rawDownloadUrl);
    if (!isFinancialArtifact) return source;

    const normalizedApiBase = String(apiBase || '').replace(/\/+$/u, '');
    let frontendHost = '';
    try {
        frontendHost = new URL(normalizedApiBase).hostname.replace(/^api\./i, '');
    } catch (error) {
        frontendHost = '';
    }
    const normalizeUrl = (value) => {
        const url = String(value || '').trim();
        if (!url) return '';
        if (url.startsWith(FINANCIAL_REPORT_PATH)) return normalizedApiBase ? `${normalizedApiBase}${url}` : url;

        try {
            const parsed = new URL(url);
            const parsedFrontendHost = parsed.hostname.replace(/^www\./i, '');
            if (normalizedApiBase && frontendHost && parsed.pathname === FINANCIAL_REPORT_PATH && parsedFrontendHost === frontendHost) {
                return `${normalizedApiBase}${parsed.pathname}${parsed.search}${parsed.hash}`;
            }
        } catch (error) {
            // Preserve malformed or non-HTTP values; the normal source opener
            // will reject anything it cannot safely resolve.
        }
        return url;
    };

    const normalizedUrl = normalizeUrl(rawUrl || rawDownloadUrl);
    const normalizedDownloadUrl = normalizeUrl(rawDownloadUrl || rawUrl);
    return {
        ...source,
        url: normalizedUrl,
        download_url: normalizedDownloadUrl,
    };
};
